import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { Box, Flex } from 'components/ui';
import FeaturedBenefitsSection from 'components/Content/BeautyInsider/BeautyInsiderBenefits/FeaturedBenefitsSection';
import NextTierBenefitsSection from 'components/Content/BeautyInsider/BeautyInsiderBenefits/NextTierBenefitsSection';
import getBenefitsViewState from 'components/Content/BeautyInsider/BeautyInsiderBenefits/benefitsViewState';
import {
    colors, mediaQueries, radii, shadows, space
} from 'style/config';

/**
 * Renders the Benefits tab sections owned by the BIHub_FeaturedBenefits Contentful placeholder.
 */
const BeautyInsiderBenefits = props => {
    const state = getBenefitsViewState(props);
    const featuredBenefits = state.featuredBenefits || props.featuredBenefits;
    const nextTierBenefits = state.nextTier;
    const viewAllBenefitsModal = props?.items?.[0]?.action;

    if (!featuredBenefits && !nextTierBenefits) {
        return null;
    }

    if (featuredBenefits && nextTierBenefits) {
        return (
            <Box data-at={Sephora.debug.dataAt('bi_benefits')}>
                <Box
                    marginBottom={[4, 5]}
                    css={styles.card}
                >
                    <Flex
                        gap={[4, 6]}
                        flexDirection={['column', 'row']}
                        css={styles.combinedSections}
                    >
                        <Box css={styles.combinedSection}>
                            <FeaturedBenefitsSection
                                section={featuredBenefits}
                                viewAllBenefitsModal={viewAllBenefitsModal}
                                isGrouped={true}
                                columns={1}
                            />
                        </Box>
                        <Box css={[styles.combinedSection, styles.nextTierSection]}>
                            <NextTierBenefitsSection
                                state={state}
                                isGrouped={true}
                            />
                        </Box>
                    </Flex>
                </Box>
            </Box>
        );
    }

    return (
        <Box data-at={Sephora.debug.dataAt('bi_benefits')}>
            <FeaturedBenefitsSection
                section={featuredBenefits}
                viewAllBenefitsModal={viewAllBenefitsModal}
            />
            <NextTierBenefitsSection state={state} />
        </Box>
    );
};

const styles = {
    card: {
        backgroundColor: colors.white,
        borderRadius: radii[2],
        boxShadow: shadows.light,
        padding: space[4],
        [mediaQueries.sm]: {
            padding: space[5]
        }
    },
    combinedSections: {
        [mediaQueries.sm]: {
            alignItems: 'flex-start'
        }
    },
    combinedSection: {
        flex: 1,
        minWidth: 0
    },
    nextTierSection: {
        borderTop: `1px solid ${colors.lightGray}`,
        paddingTop: space[4],
        [mediaQueries.sm]: {
            borderTop: 0,
            paddingTop: 0
        }
    }
};

export default wrapFunctionalComponent(BeautyInsiderBenefits, 'BeautyInsiderBenefits');
